var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'demo' && _vm.showFooter)?_c('div',{staticClass:"demo-footer"},[_c('div',{staticClass:"demo-footer-inner",class:_vm.activityType === 'groupType' ? 'group' : '',style:({
      background: _vm.buttonSection.backgroundColor,
      color: _vm.buttonSection.textColor
    }),on:{"click":_vm.checkXmPay}},[_vm._v("\n    马上制作\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }